import React from "react";
import PropTypes from "prop-types";
import invariant from "fbjs/lib/invariant";
import classNames from "classnames";
import icons from "theme/components/atoms/Icon/icons";

export const whitelist = [
  ...Object.keys(icons.componentIcons),
  ...icons.svgIcons,
].sort();

const wrapperComponents = {
  default: ({ children }) => {
    return children;
  },
  withAppearance: ({ children, appearance, size }) => {
    const className = classNames("icon-wrapper", {
      [`icon-wrapper--${appearance}`]: appearance,
      [`icon-wrapper--${size}`]: size,
    });
    return <div className={className}>{children}</div>;
  },
};

const Icon = ({ icon, size, title, appearance }) => {
  invariant(
    whitelist.indexOf(icon) > -1,
    `"${icon}" is not a whitelisted icon`
  );

  if (process.env.NODE_ENV === "development" && title === undefined) {
    console.warn(
      "You must set a title (it can be an empty string if you don't want one) to use <Icon />."
    );
  }

  const className = classNames("icon", {
    [`icon--${size}`]: size,
    [`icon--${appearance}`]: appearance,
  });

  const Wrapper = appearance
    ? wrapperComponents.withAppearance
    : wrapperComponents.default;

  if (icons.svgIcons.indexOf(icon) > -1) {
    return (
      <Wrapper appearance={appearance} size={size}>
        <img
          title={title}
          src={`/images/icons/${icon}.svg`}
          alt=""
          className={className}
        />
      </Wrapper>
    );
  } else {
    const IconComponent = icons.componentIcons[icon];
    return (
      <Wrapper appearance={appearance} size={size}>
        <IconComponent title={title} className={className} />
      </Wrapper>
    );
  }
};

Icon.defaultProps = {
  size: "default",
  appearance: "default",
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  appearance: PropTypes.oneOf([
    "default",
    "default-block",
    "block",
    "round",
    "round-border",
  ]),
  size: PropTypes.oneOf(["default", "small", "mini", "big"]),
  title: PropTypes.string.isRequired,
};

export default Icon;
